import React, { useEffect, useState } from "react";
import Post from "../post/Post";
import "../../App.css";
import { db } from "../service/firebase";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Slides from "../slides/Slides";
import Rightside from "../RightPanel/Rightside";
function Home() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    db.collection("posts")
      .orderBy("timestamp", "desc")
      .onSnapshot((snapshot) => {
        setPosts(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            post: doc.data(),
          }))
        );
      });
  }, [posts]);

  const toTop = () =>
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

  return (
    <>
      <Slides />
      <div className="PostArea row">
        <div className="col">
          {posts.map(({ id, post }) => (
            <Post
              key={id}
              commentId={id}
              id={post.username + id}
              username={post.username}
              postImage={post.postImage}
              caption={post.caption}
            />
          ))}
          <button
            type="button"
            className="btn btn-dark scrollToTop"
            onClick={toTop}
          >
            <FontAwesomeIcon icon={faArrowUp} />
          </button>
        </div>
        <div className="col-4 RightPanel bg-light">
          <Rightside />
        </div>
      </div>
    </>
  );
}

export default Home;
